import constants from "../constants";
import * as moment from 'moment-timezone';

export const addScan = code => ({
  type: constants.ADD_SCAN,
  value: {
    code,
    time: moment().toISOString(),
  },
});